// Polyfill navigator.locks for iframe/preview environments where it times out
if (typeof navigator !== 'undefined' && navigator.locks) {
  const originalRequest = navigator.locks.request.bind(navigator.locks);
  (navigator.locks as any).request = async (name: string, ...args: any[]) => {
    try {
      return await Promise.race([
        originalRequest(name, ...args),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Lock timeout')), 3000)
        ),
      ]);
    } catch {
      // Fallback: execute callback without lock
      const cb = args[args.length - 1];
      if (typeof cb === 'function') return cb({ name, mode: 'exclusive' });
    }
  };
}
